import { useState } from 'react';
import { DocumentProcessor } from '../components/features';

const NewSupplier = () => {
  const [processedDocuments, setProcessedDocuments] = useState([]);

  const handleDocumentProcessed = (result) => {
    setProcessedDocuments([...processedDocuments, result]);
  };

  return (
    <DocumentProcessor 
      onDocumentProcessed={handleDocumentProcessed}
    />
  );
};

export default NewSupplier;
